"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _clsx = _interopRequireDefault(require("clsx"));
var _IconButton = _interopRequireDefault(require("../../IconButton"));
var _excluded = ["bottomArrows", "className", "left", "outsideArrows", "right"];
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
var styles = {
  "arrow": "TbcZ-F",
  "middleArrows": "QQWVV4",
  "left": "AJ2hIw",
  "outsideArrows": "DRQ45Y",
  "right": "FMF-Ek"
};
var Arrow = function Arrow(_ref) {
  var bottomArrows = _ref.bottomArrows,
    className = _ref.className,
    left = _ref.left,
    outsideArrows = _ref.outsideArrows,
    right = _ref.right,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_IconButton["default"], _extends({
    className: (0, _clsx["default"])(className, styles.arrow, left && styles.left, right && styles.right, outsideArrows && styles.outsideArrows, !bottomArrows && styles.middleArrows)
  }, props));
};
Arrow.propTypes = process.env.NODE_ENV !== "production" ? {
  bottomArrows: _propTypes["default"].bool,
  className: _propTypes["default"].string,
  left: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  outsideArrows: _propTypes["default"].bool,
  right: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number])
} : {};
var _default = exports["default"] = Arrow;